import { Box } from "@mui/material";
import React from "react";
import { ChatContainer } from "../style";
import AiSearchContent from "./AiSearchContent";
import AiSearchInput from "./AiSearchInput";

const SearchBox = () => {
  return (
    <Box sx={ChatContainer}>
      <AiSearchContent />
      <AiSearchInput />
    </Box>
  );
};

export default SearchBox;
